import { QUEUE_VIEW } from '../../constants/onboardingQueue';

export const selectOnboardingQueue = state => state.data.onboardingQueue;

export const selectQueueView = (state, view) => selectOnboardingQueue(state)[view];

export const selectQueueFilters = state => selectOnboardingQueue(state).filters;

export const selectQueueLoaded = state => selectOnboardingQueue(state).loaded;

export const selectQueueLoading = state => selectOnboardingQueue(state).loading;

export const selectQueueRefreshing = state => selectOnboardingQueue(state).refreshing;

export const selectViewTotal = (state, view) => {
  const slice = selectQueueView(state, view);
  return slice.error ? null : slice.totalRows;
};

export const selectFiltersActive = state => {
  const { search, from, to } = selectQueueFilters(state);
  return Boolean(search || from || to);
};

export const selectPendingTotal = state => selectViewTotal(state, QUEUE_VIEW.PENDING);

export const selectCompletedTotal = state => selectViewTotal(state, QUEUE_VIEW.COMPLETED);
